import {Component, Vue} from "vue-property-decorator";

@Component
export class MessageBox extends Vue {
  render() {
    return (
      <div class="message">
        <p class="message-body">{this.$slots.default}</p>
      </div>
    );
  }
}

@Component
export class MessageBoxError extends Vue {
  render() {
    return <MessageBox class="is-danger">{this.$slots.default}</MessageBox>;
  }
}

@Component
export class MessageBoxSuccess extends Vue {
  render() {
    return <MessageBox class="is-success">{this.$slots.default}</MessageBox>;
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-7cdc8fcf/message-box.tsx" });